module.exports = "<infoClienteIndividual *ngIf=\"!bandera\"></infoClienteIndividual>\r\n<infoClienteEmpresa *ngIf=\"bandera\"></infoClienteEmpresa>"


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/datosGenerales/datos-generales.template.html
// module id = ../../../../../src/app/views/masivos/datosGenerales/datos-generales.template.html
// module chunks = 0